import { t } from 'src/lib/i18n'
export const PLACEMENT_TEST_LEVELS = [
  {
    cefrLevel: 'a1',
    name: t('Beginner'),
    start: 2, //maps to level 1.2 in our system
  },
  {
    cefrLevel: 'b1',
    name: t('Intermediate'),
    start: 6, //maps to level 1.6 in our system
  },
  {
    cefrLevel: 'c1',
    name: t('Advanced'),
    start: 10, //maps to level 2.0 in our system
  },
]

export const MOCK_SELF_ASSESSMENT_LEVELS = [
  {
    code: 'a1',
    label: 'Beginner',
    description:
      'You’re right at the beginning of your journey! Don’t worry, we’ve got you covered!',
    start: 'start',
  },
  {
    code: 'a1',
    label: 'Beginner',
    description:
      'If you can already introduce and answer basic ques…d weather, this is your place. Let’s keep moving!',
    start: 'middle',
  },
  {
    code: 'a2',
    label: 'Elementary',
    description:
      'You’ve completed A1 or equivalent. You can already…espond to requests. You can only go up from here!',
    start: 'start',
  },
  {
    code: 'a2',
    label: 'Elementary',
    description:
      'At this level you can talk about hobbies, vacation…sts and give your opinion. Keep up the good work!',
    start: 'middle',
  },
  {
    code: 'b1',
    label: 'Intermediate',
    description:
      'You’ve completed A2 or equivalent. You are able to…r emotions. Let’s move on to more complex topics!',
    start: 'start',
  },
  {
    code: 'b1',
    label: 'Intermediate',
    description:
      'If you can talk about your dreams, understand the …art here. Let’s finish what we started, shall we?',
    start: 'middle',
  },
  {
    code: 'b2',
    label: 'Upper Intermediate',
    description:
      'You’ve completed B1 or equivalent. At this level y… yourself. You are nailing it. Let’s go for more!',
    start: 'start',
  },
  {
    code: 'b2',
    label: 'Upper Intermediate',
    description:
      'You can have conversations about abstract or philo…lity, and tone used in various social situations.',
    start: 'middle',
  },
  {
    code: 'c1',
    label: 'Advanced',
    description:
      "You've completed B2 or equivalent. At this level, …ffairs, politics or history. No one can stop you!",
    start: 'start',
  },
]

export const MOCK_USER_CEFR_LEVEL = {
  id: 1,
  code: 'a1',
  start: 'middle',
}

//TODO: put cefrLevelProgress under the cefrLevel object

//TODO do provide some mock data for the tests

export const MOCK_LANGUAGE_DATA = {
  languageCode: 'fr',
}
